import { useState, useEffect } from "react";
import WooService from "../services/WooService";

export default (setRefreshing) => {
  const [orders, setOrders] = useState([]);
  const wooService = new WooService();

  const loadOrders = async () => {
    const wooOrders = await wooService.getWooOrders();
    setOrders(wooOrders);
  }

  useEffect(() => {
    async function getOrders() {
      setRefreshing(true);
      await loadOrders();
      setRefreshing(false);
    }
    getOrders();
  }, []);

  return [orders, setOrders, loadOrders];
}